export const selectText = (el: HTMLElement) => {
    const selection = getSelection();
    if (!selection) throw new Error("Selection not found in browser.");
    const range = document.createRange();
    range.selectNodeContents(el);
    selection.removeAllRanges();
    selection.addRange(range);
};
